@if (deviceType == "noise_sensor") {
    <mat-icon>settings_input_antenna</mat-icon>
}
@if (deviceType == "acoustic_limiter") {
    <fa-icon [icon]="limiterIcon" size="lg"></fa-icon>
}
